import React__default, { useRef } from 'react';
import { Notice } from '../../Notice/index.js';
import { Fader } from './Fader.js';

/**
 * Component showing a NotificationBar that fades out after a specified timeout.
 * It provides a callback for when the fade animation starts (onRemoving) and
 * another one for when the animation ends (onRemove).
 */
const NotificationBar = ({ variant, size, children, removeAfter, onRemoved, closeable = false, }) => {
    const faderRef = useRef(null);
    const onClickClose = () => {
        faderRef.current?.remove();
    };
    return (React__default.createElement(Fader, { ref: faderRef, removeAfter: removeAfter, onRemoved: onRemoved },
        React__default.createElement(Notice, { size: size, variant: variant, contentCentered: true, closeConfiguration: closeable ? { onClick: onClickClose } : undefined }, children)));
};
NotificationBar.displayName = 'NotificationBar';

export { NotificationBar };
//# sourceMappingURL=index.js.map
